import {match} from 'ts-pattern';

import {VehicleCondition} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const getVehicleConditionLabel = (condition: VehicleCondition): string =>
  match(condition)
    .with('CONDITION_DEMONSTRATION_CAR', () => i18n.t('entity.vehicle.labels.demonstrationCar'))
    .with('CONDITION_USED', () => i18n.t('entity.vehicle.labels.used'))
    .otherwise(() => condition);
